import Vue from 'vue';  
import Vuex from 'vuex'; 
//vuex数据保存持久化插件
import VuexPersistence from 'vuex-persist';
//使用插件
const vuexLocal = new VuexPersistence({  
  storage: window.localStorage  
}).plugin; 
  
Vue.use(Vuex);  
  
export default new Vuex.Store({  
  state: {  
    menus: []  
  },  
  mutations: {  
    setMenus(state, menus) {  
      state.menus = menus;  
    }  
  },
  plugins: [vuexLocal]    
});